import { supabase } from './supabase'

// Bloque G1 — Turnero. Dispara el mail de turno (confirmación / cancelación
// / reprogramación) sin bloquear la acción que ya se hizo sobre el turno:
// si el envío falla, se loguea y sigue. functions.invoke() NO rechaza ante
// un error de la función (resuelve con { error }), así que hay que chequear
// las dos cosas: el error devuelto y un fallo real de red en el .catch().
export function notificarTurno(turnoId, evento) {
  return supabase.functions
    .invoke('notificar-turno', { body: { turno_id: turnoId, evento } })
    .then(({ error }) => {
      if (error) console.error(`[notificar-turno] ${evento} turno ${turnoId}:`, error)
    })
    .catch(err => console.error(`[notificar-turno] ${evento} turno ${turnoId} (red):`, err))
}
